// Shared button styling constants
export const BUTTON_STYLES = {
  // Background colors
  BACKGROUND_DEFAULT: 'rgba(31, 41, 55, 0.3)',
  BACKGROUND_HOVER: 'var(--primary-color)',
  
  // Text colors
  TEXT_DEFAULT: 'var(--text-primary)',
  TEXT_HOVER: 'white',
  
  // Dimensions
  SIZE: '44px',
  
  // Border radius
  BORDER_RADIUS_SQUARE: '8px',
  BORDER_RADIUS_CIRCLE: '50%',
  
  // Other properties
  BORDER: '1px solid var(--glass-border)',
  BOX_SHADOW: '0 2px 8px rgba(0, 0, 0, 0.15)',
  TRANSITION: 'background-color 0.2s, color 0.2s',
  FONT_SIZE: '1.2rem'
} as const;

// Base button style object
export const getBaseButtonStyles = (isCircular: boolean = false): React.CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: BUTTON_STYLES.SIZE,
  height: BUTTON_STYLES.SIZE,
  borderRadius: isCircular ? BUTTON_STYLES.BORDER_RADIUS_CIRCLE : BUTTON_STYLES.BORDER_RADIUS_SQUARE,
  background: BUTTON_STYLES.BACKGROUND_DEFAULT,
  color: BUTTON_STYLES.TEXT_DEFAULT,
  cursor: 'pointer',
  transition: BUTTON_STYLES.TRANSITION,
  fontSize: BUTTON_STYLES.FONT_SIZE,
  boxShadow: BUTTON_STYLES.BOX_SHADOW,
  border: BUTTON_STYLES.BORDER,
});

// Hover event handlers
export const getHoverHandlers = () => ({
  onMouseEnter: (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.background = BUTTON_STYLES.BACKGROUND_HOVER;
    e.currentTarget.style.color = BUTTON_STYLES.TEXT_HOVER;
  },
  onMouseLeave: (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.background = BUTTON_STYLES.BACKGROUND_DEFAULT;
    e.currentTarget.style.color = BUTTON_STYLES.TEXT_DEFAULT;
  }
});
